// extracted by mini-css-extract-plugin
export default {"heading":"_1V07L0uFY8yFTY1SJxMY3D"};